import useMe from "./useMe";
import roles from "../consts/roles";

const useShowAccount = () => {
    const {role} = useMe();
    return role===roles.CEO || role===roles.ADMIN || role===roles.HEAD;
};

export default useShowAccount;